import { useHistory } from 'react-router-dom';
import About from '../../../assets/Site/about.png';
import Header from '../Header';
import { Button, Container, Content, Image, Title } from './styles';

export function Success() {
  const history = useHistory();
  const planId = localStorage.getItem('selectedProduct');
  const predictaOne = process.env.REACT_APP_PREDICTA_PRODUCT_ONE_ID;
  const orderIsPredictaOne = predictaOne === planId;
  return (
    <>
      <Header step={'userData'} handleStep={() => console.log('a')}/>
      <Container>
        <Content>
          <Title> Seu pedido foi realizado com sucesso!</Title>
          { orderIsPredictaOne
            ? <p>Após o recebimento do e-mail de confirmação de pagamento, você receberá o seu kit de coleta em até 5 dias úteis, no endereço informado no ato da compra. </p>
            : <p>Após o recebimento do e-mail de confirmação de pagamento, você poderá efetuar o agendamento da sua consulta pré-teste ligando <b>ligando</b> para <b>(11) 2151-6381</b>, <b>(11) 2151-0408</b> ou entrando em contato com a nossa equipe pelo <b>Whatsapp: (11) 3620-2550</b>. </p>
          }

          <Image src={About}/>
          <h5>* Em caso de dúvida entre em contato nos canais de atendimento disponíveis em nosso site. </h5>
          <Button onClick={() => history.push('/')}>
            Voltar à página inicial
          </Button>
        </Content>
      </Container>
    </>
  );
};
